export default {
  path: '/lottery',
  name: 'Lottery',
  component: () => import('@/views_lottery/view.vue'),
  redirect: '/lottery/index',
  children: [
    {
      path: '/lottery/index',
      name: 'Lottery',
      component: () => import('@/views_lottery/index.vue'),
      meta: { navBar: false, }
    },
    {
      path: '/lottery/rule',
      name: 'Rule',
      component: () => import('@/views_lottery/rule.vue'),
      meta: { navBar: true, title: '规则说明' }
    },
    {
      path: '/lottery/record',
      name: 'Record',
      component: () => import('@/views_lottery/record.vue'),
      meta: { navBar: true, title: '中奖记录' }
    },
    {
      path: '/lottery/exchange',
      name: 'Exchange',
      component: () => import('@/views_lottery/exchange.vue'),
      meta: { navBar: true, title: '确认兑换' }
    },
    {
      path: '/lottery/success',
      name: 'Success',
      component: () => import('@/views_lottery/success.vue'),
      meta: { navBar: true, title: '兑换成功', back: -2 }
    }
  ]
}